<template>
    <div>
        <div class="row well">
            <table class="table">
                <tr v-for="age in ageList">
                    <td style="width:20%">
                        <div class="checkbox checkbox-inline">
                            <input type="checkbox" v-model="age.isSelected" v-bind:id="parentFormName + age.selectId" v-bind:value="age.isSelected">
                                <label v-bind:for="parentFormName + age.selectId">{{ age.description}}</label>
                            </input>
                        </div>
                    </td>
                    <td v-show="age.isSelected" style="width:10%">
                        <div class="checkbox checkbox-inline">
                            <input type="checkbox" v-model="age.isSurface" v-bind:id="parentFormName + 'surface' + age.selectId" v-bind:value="age.isSurface">
                                <label v-bind:for="parentFormName + 'surface' + age.selectId">Surface</label>
                            </input>
                        </div>
                    </td>
                    <td v-show="age.isSelected" style="width:10%">
                        <div class="checkbox checkbox-inline">
                            <input type="checkbox" v-model="age.isSubsurface" v-bind:id="parentFormName + 'subsurface' + age.selectId" v-bind:value="age.isSubsurface">
                                <label v-bind:for="parentFormName + 'subsurface' + age.selectId">Subsurface</label>
                            </input>
                        </div>
                    </td>
                    <td v-show="age.isSelected && phaseFilter(age.selectId).length > 0" >
                        <select class="form-control" style="width:150px" v-model="age.prehistoricPhaseId">
                            <option value=''>Select a phase</option>
                            <option v-for="phase in phaseFilter(age.selectId)" v-bind:value="phase.prehistoricPhaseId">
                                {{phase.description}}
                            </option>
                        </select>
                    </td>
                </tr>
            </table>
            <div v-if="isDebug">
               <pre>
                Prehistoric? {{isPrehistoric}}
               </pre>
            </div>
        </div>
    </div>
</template>

<script>
import significantPeriodService from '@/services/siteForm/significantPeriodService.js'
import loggingService from '@/services/util/loggingService'

export default {
    name: 'ageSelection',
    props: ['isPrehistoric', 'parentFormName'],
    data: function () {
        return {
            isDebug: false,
            ageList: [],
            /*selectedList: [],
            selectedSubsufaceList: [],
            selectedSurfaceList: [],
            selectedSubsurfaceList: [],*/
            prehistoricPhaseList: []
        }
    },
    mounted () {
        this.loadLookups()
        this.loadData()
    },
    methods: {
        log (message) {
            loggingService.log(this.isDebug, 'Age Selection', message)
        },
        loadLookups () {
            if (this.isPrehistoric) {
                this.ageList = significantPeriodService.getPrehistoricAgeList().map(x => {
                    x.isSelected = false
                    x.isSurface = false
                    x.isSubsurface = false
                    x.prehisoricPhaseId = ''
                    x.selectId = x.prehistoricAgeId
                    return x
                })
                this.prehistoricPhaseList = significantPeriodService.getPrehistoricPhaseList()
            } else {
                this.ageList = significantPeriodService.getSignificantPeriodList().filter(x => {
                    return x.description !== 'Prehistoric'
                }).map(x => {
                    x.isSelected = false
                    x.isSurface = false
                    x.isSubsurface = false
                    x.prehisoricPhaseId = ''
                    x.selectId = x.significantPeriodId
                    return x
                })
            }
        },
        loadData () {
        },
        phaseFilter (ageId) {
            if (!this.isPrehistoric) return []
            switch (ageId) {
            case 3: //Early Archaic
                return this.prehistoricPhaseList.filter(x => { return x.prehistoricPhaseId <= 2 })
            case 4: // Middle Archaic
                return this.prehistoricPhaseList.filter(x => { return x.prehistoricPhaseId === 2 || x.prehistoricPhaseId === 3 })
            case 5: // Late Archaic
                return this.prehistoricPhaseList.filter(x => { return x.prehistoricPhaseId === 4 })
            case 7: //Late Prehistoric
                return this.prehistoricPhaseList.filter(x => { return x.prehistoricPhaseId === 5 || x.prehistoricPhaseId === 6 })
            default:
                return []
            }
        },
        setSelection (selectedList) {
            this.log('Setting selections, count: ' + selectedList.length)
            this.ageList.forEach(age => {
                var selection = selectedList.find(s => { return age.selectId === s.significantPeriodId })
                if (selection) {
                    age.isSelected = true
                    age.isSurface = selection.isSurface
                    age.isSubsurface = selection.isSubsurface
                    age.prehistoricPhaseId = selection.prehistoricPhaseId
                }
            })
        }
    }
}
</script>



// WEBPACK FOOTER //
// ageSelection.vue?da931fe2